import { State } from '../../reducers/rootReducer'
import Model from '../../../entities/Model'

const modelsSelector = (state: State): Model[] => state.modelData.models

export default modelsSelector
